import { create } from "zustand";

export const INITAL_PAGE = 1;
export const INITAL_PAGE_SIZE = 10;
export const INITAL_SEARCH = "";
export const INITAL_SEARCH_FILTER = "keyword";
export const INITAL_PURPOSE = 1;
export const INITAL_PURPOSE_STATUS = [1];
export const INITAL_CATEGORIES = [];
export const INITAL_SUBCATEGORIES = [];
export const INITAL_REPRESENTATIVES = [];
export const INITAL_OFFICES = [];
export const INITAL_DISPLAY_STATUS = [2, 3];
export const INITAL_STATUS = "";
export const INITAL_PRICE_MIN = 0;
export const INITAL_PRICE_MAX = 0;

const useEstatesFilterStore = create((set) => ({
  page: INITAL_PAGE,
  pageSize: INITAL_PAGE_SIZE,
  search: INITAL_SEARCH,
  searchFilter: INITAL_SEARCH_FILTER,
  purpose: INITAL_PURPOSE,
  purposeStatus: INITAL_PURPOSE_STATUS,
  categories: INITAL_CATEGORIES,
  subCategories: INITAL_SUBCATEGORIES,
  representatives: INITAL_REPRESENTATIVES,
  offices: INITAL_OFFICES,
  displayStatus: INITAL_DISPLAY_STATUS,
  status: INITAL_STATUS,
  priceMin: INITAL_PRICE_MIN,
  priceMax: INITAL_PRICE_MAX,
  isTopParent: true,
  setPage: (page) => set({ page }),
  setSearch: (search, searchFilter) =>
    set({ search, searchFilter, page: INITAL_PAGE }),
  setPurpose: (purpose) =>
    set({
      purpose,
      purposeStatus: INITAL_PURPOSE_STATUS,
    }),
  submitFilter: (filter) => set({ ...filter }),
  resetFilter: () =>
    set({
      purpose: INITAL_PURPOSE,
      purposeStatus: INITAL_PURPOSE_STATUS,
      categories: INITAL_CATEGORIES,
      subCategories: INITAL_SUBCATEGORIES,
      representatives: INITAL_REPRESENTATIVES,
      offices: INITAL_OFFICES,
      displayStatus: INITAL_DISPLAY_STATUS,
      status: INITAL_STATUS,
      priceMin: INITAL_PRICE_MIN,
      priceMax: INITAL_PRICE_MAX,
      isTopParent: false,
    }),
  resetQuickFilter: () =>
    set({
      purposeStatus: INITAL_PURPOSE_STATUS,
      representatives: INITAL_REPRESENTATIVES,
      offices: INITAL_OFFICES,
      displayStatus: INITAL_DISPLAY_STATUS,
    }),
}));

export default useEstatesFilterStore;
